export default "__VITE_ASSET__iMrQrpOJ__"